// extracted by mini-css-extract-plugin
module.exports = {"bread-crumb-desktop":"bread-crumb-desktop_bread-crumb-desktop__O0iAd"};